/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function DataTypeJson12(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'DataTypeJson12',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M1 0a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm3.983 3H5v1c-.196 0-.334 0-.448.015a.4.4 0 0 0-.168.048c-.01.007-.134.096-.134.687A1.7 1.7 0 0 1 3.714 6a1.7 1.7 0 0 1 .536 1.25c0 .591.125.68.134.687a.4.4 0 0 0 .168.048C4.666 7.999 4.804 8 5 8v1h-.017c-.175 0-.374 0-.558-.024a1.34 1.34 0 0 1-.622-.225c-.43-.307-.553-.846-.553-1.501 0-.436-.387-.75-.75-.75v-1c.363 0 .75-.314.75-.75 0-.655.124-1.194.553-1.5.203-.145.427-.201.622-.226C4.609 3 4.808 3 4.983 3m2.034 0H7v1c.196 0 .334 0 .448.015.11.015.152.037.168.048.01.007.134.096.134.687 0 .518.217.947.536 1.25a1.7 1.7 0 0 0-.536 1.25c0 .591-.125.68-.134.687a.4.4 0 0 1-.168.048A4 4 0 0 1 7 8v1h.017c.175 0 .374 0 .558-.024.195-.025.42-.08.622-.225.43-.307.553-.846.553-1.501 0-.436.387-.75.75-.75v-1c-.363 0-.75-.314-.75-.75 0-.655-.124-1.194-.553-1.5a1.34 1.34 0 0 0-.622-.226C7.391 3 7.192 3 7.017 3"}))
}
